import React from "react";

import DefaultSideBarOptions from './DefaultRoutes/DefaultMenuOptions';
import ProveedorMenuOptions from "./ProveedorRoutes/ProveedorMenuOptions";
var AppMenuOptions =[];
AppMenuOptions = AppMenuOptions.concat(DefaultSideBarOptions);
AppMenuOptions = AppMenuOptions.concat(ProveedorMenuOptions);


export default AppMenuOptions;